import i18next from 'i18next';

i18next.addResources('es_CL', 'OrdersTableBody', {
  canceled: 'Anulada',
  cash: 'Efectivo',
  completed: 'Cumplida',
  created: 'Por aceptar',
  creationScheduled: 'Programada',
  inStore: 'Retiro',
  inTransit: 'En tránsito',
  preparing: 'Preparación',
  readyInStore: 'Listo p. retiro',
  readyStoreDelivery: 'En tránsito',
  storeDelivery: 'Delivery',
  uber: 'Uber',
  web: 'Web',
  webPay: 'WebPay',
  cashPayed: 'No es posible cambiar de delivery. El pedido fue pagado en efectivo.',
  cardPayed: `No es posible cambiar de delivery. El pedido fue pagado con tarjeta al recibir.`,
  externalDelivery: 'No es posible cambiar de delivery. El pedido ya fue aceptado por un delivery externo.',
  pickUpDelivery: 'No es posible cambiar de delivery. El pedido es con retiro en tienda.',
  noAlternatives: 'No es posible cambiar de delivery. No tienes deliveries externos integrados con Mercat.',
  changeDelivery: 'Cambiar delivery.',
  assignDelivery: 'Asignar delivery.',
  in_store: 'Retiro en tienda',
  sinpe: 'Sinpe',
  credit: 'Crédito',
  no_charge: 'Sin cargo',
  noCharge: 'Sin cargo',
  klapWallets: 'Google Pay / Apple Pay',
  klapSodexo: 'Pluxee',
  klapEdenred: 'Edenred'
});

i18next.addResources('es_CR', 'OrdersTableBody', {
  canceled: 'Anulada',
  cash: 'Efectivo',
  completed: 'Cumplida',
  created: 'Por aceptar',
  creationScheduled: 'Programada',
  inStore: 'Retiro',
  inTransit: 'En tránsito',
  preparing: 'Preparación',
  readyInStore: 'Listo p. retiro',
  readyStoreDelivery: 'En tránsito',
  storeDelivery: 'Delivery',
  uber: 'Uber',
  web: 'Web',
  webPay: 'WebPay',
  cashPayed: 'No es posible cambiar de delivery. El pedido fue pagado en efectivo.',
  cardPayed: `No es posible cambiar de delivery. El pedido fue pagado con tarjeta al recibir.`,
  externalDelivery: 'No es posible cambiar de delivery. El pedido ya fue aceptado por un delivery externo.',
  pickUpDelivery: 'No es posible cambiar de delivery. El pedido es con retiro en tienda.',
  noAlternatives: 'No es posible cambiar de delivery. No tienes deliveries externos integrados con Mercat.',
  changeDelivery: 'Cambiar delivery.',
  assignDelivery: 'Asignar delivery.',
  in_store: 'Retiro en tienda',
  sinpe: 'Sinpe',
  credit: 'Crédito',
  no_charge: 'Sin cargo',
  noCharge: 'Sin cargo',
  klapWallets: 'Google Pay / Apple Pay',
  klapSodexo: 'Pluxee',
  klapEdenred: 'Edenred'
});
